import { Node } from '@tiptap/core'

import './LeadForm.scss'

export enum LeadFormItemType {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  Email = 'EMAIL',
  Phone = 'PHONE',
  Text = 'TEXT'
}

export interface LeadFormItem {
  label: string,
  type: LeadFormItemType
}

const InputTypes = {
  [LeadFormItemType.FirstName]: 'text',
  [LeadFormItemType.LastName]: 'text',
  [LeadFormItemType.Text]: 'text',
  [LeadFormItemType.Email]: 'email',
  [LeadFormItemType.Phone]: 'tel',
}

const renderFormItems = (formItems: LeadFormItem[]) => {
  return formItems.map(formItem => {
    return ['label', {}, formItem.label,
      ['input',
        {
          name: formItem.label.toLocaleLowerCase().replaceAll(' ', '_'),
          autocomplete: false,
          type: InputTypes[formItem.type],
          required: true,
        }
      ]
    ]
  })
}

const renderConsentCheckbox = (consentText: string) => {
  return consentText ?
    [['div', {class: 'consent-wrapper'},
      ['input', { type: "checkbox", required: true }],
      ['span', {}, consentText]
    ]] : []
}
declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    leadform: {
      ínsertLeadForm: (attributes?: { formItems: LeadFormItem[], ctaButtonText: string, consentText: string, publicationId: string }) => ReturnType,
    }
  }
}

const LeadForm = Node.create({
  name: 'leadform',


  addAttributes() {
    return {
      formItems: {
        default: []
      },
      consentText: {
        default: '',
      },
      ctaButtonText: {
        default: 'Submit',
      },
    };
  },

  group: 'block',
  defining: true,

  renderHTML({HTMLAttributes }) {
    return [
      'form',
      { autocomplete: "off", method: "post", "data-netlify": "true" },
      ...renderFormItems(HTMLAttributes.formItems),
      ...renderConsentCheckbox(HTMLAttributes.consentText),
      ['button', { class:"btn", disabled: true, type: "submit"}, HTMLAttributes.ctaButtonText]
    ]
  },

  addCommands() {
    return {
      ínsertLeadForm: attrs => ({ commands }) => {
        return commands.insertContent({ type: this.name, attrs })
      },
    }
  },
})

export default LeadForm
